export default "__VITE_ASSET__CJ$Im3Lq__"